<template>
  <v-dialog v-model="showPopup" persistent max-width="520">
    <v-card class="pa-4">
      <v-card-title class="headline justify-center popup-title">
        Are you sure you want to leave this page without saving your changes?
      </v-card-title>
      <v-card-actions class="text-xs-center justify-center">
        <v-btn
          @click="cancel"
          depressed
          class="cancel-btn small-size"
        >
          Cancel
        </v-btn>
        <v-btn
          @click="confirm"
          depressed
          class="save-btn small-size"
        >
          Confirm
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { MODULE_POPUP, SET_UNSAVED_CHANGES_POPUP_SHOW, MODULE_FORM, SET_FORM_DATA_ORIGIN, SET_FORM_DATA_NEW } from '@/store/constant/mutation-types'

export default {
  name: 'UnsavedChangesPopup',
  props: [],
  data() {
    return {
    }
  },
  computed: {
    showPopup() {
      return this.$store.getters[`${MODULE_POPUP}/showUnsavedChangesPopup`]
    }
  },
  methods: {
    confirm() {
      this.$emit('confirm')
      this.$store.commit(`${MODULE_FORM}/${SET_FORM_DATA_ORIGIN}`, {})
      this.$store.commit(`${MODULE_FORM}/${SET_FORM_DATA_NEW}`, {})
      this.$store.commit(`${MODULE_POPUP}/${SET_UNSAVED_CHANGES_POPUP_SHOW}`, false)
      this.$router.back()
    },
    cancel() {
      this.$store.commit(`${MODULE_POPUP}/${SET_UNSAVED_CHANGES_POPUP_SHOW}`, false)
    }
  }
}
</script>

<style scoped>

</style>
